module.exports = __webpack_public_path__ + "static/media/employment.e0e44513.png";